module.exports = "/_next/static/resources/box-0855f8956174f0d9e6440d2c2370ff69.webp";